export default __webpack_public_path__ + "static/media/dized.7d02423c.svg";